export const dashboardQueryKeys = {
	all: ["dashboard"] as const,
	broker: () => [...dashboardQueryKeys.all, "broker"] as const,
	brokerPendingReceipts: () =>
		[...dashboardQueryKeys.broker(), "pending-receipts"] as const,
	brokerTasks: () => [...dashboardQueryKeys.broker(), "tasks"] as const,
	brokerProjects: () => [...dashboardQueryKeys.broker(), "projects"] as const,
	syndic: () => [...dashboardQueryKeys.all, "syndic"] as const,
	syndicTasks: () => [...dashboardQueryKeys.syndic(), "tasks"] as const,
	syndicProjects: () => [...dashboardQueryKeys.syndic(), "projects"] as const,
	assureur: () => [...dashboardQueryKeys.all, "assureur"] as const,
	assureurTasks: () => [...dashboardQueryKeys.assureur(), "tasks"] as const,
	assureurProjects: () =>
		[...dashboardQueryKeys.assureur(), "projects"] as const,
	assureurReceipts: () =>
		[...dashboardQueryKeys.assureur(), "receipts"] as const,
};
